import { useState, useEffect } from 'react';

function useAudioPlayer() {
  const [duration, setDuration] = useState<number>(NaN);
  const [curTime, setCurTime] = useState<number>(NaN);
  const [clickedTime, setClickedTime] = useState<number>();

  useEffect(() => {
    const audio = document.getElementById('audio') as HTMLAudioElement;

    // state setters wrappers
    const setAudioData = () => {
      setDuration(audio.duration);
      setCurTime(audio.currentTime);
    };

    const setAudioTime = () => setCurTime(audio.currentTime);

    // DOM listeners: update React state on DOM events
    audio.addEventListener('loadeddata', setAudioData);

    audio.addEventListener('timeupdate', setAudioTime);

    if (clickedTime && clickedTime !== curTime) {
      audio.currentTime = clickedTime;
      setClickedTime(undefined);
    }

    // effect cleanup
    return () => {
      audio.removeEventListener('loadeddata', setAudioData);
      audio.removeEventListener('timeupdate', setAudioTime);
    };
  }, [clickedTime, curTime]);

  return {
    curTime,
    duration,
    setClickedTime,
  };
}

export default useAudioPlayer;
